import React, { Component, Fragment } from 'react';

import DEFINE from '../../../../../../../../constants/Define';
import { TourType } from '../../../../../../../../models/Tour';

import {
    FormWrapperInputComponent,
} from "../../../../../../common/component/Index";
import AntSelect, { AntOption } from '../../../../../../common/component/AntSelect';
import Wrapper from '../../../../../../common/component/Wrapper';
import Ripple from '../../../../../../common/component/Ripple';
import Modal from '../../../../../../common/component/Modal';
import Input from '../../../../../../common/component/Input';

import { Divider, Icon } from 'antd';

import './TourTypes.less';
import Span from '../../../../../../common/component/Span';

export default class TourTypes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            isShowAddModal: false,
            editTourType: undefined,
        };
    }

    render() {
        const { t, tourTypes, selections, loading } = this.props;
        return (
            <Fragment>
                <AntSelect className="select-tour-types tourTypes"
                    showArrow loading={loading}
                    mode="multiple"
                    placeholder={t(`item.tour.selectTourTypes`)}
                    value={selections.map(item => item.id)}
                    onChange={this.props.onChange}
                    style={{ width: '100%' }}
                    filterOption={this.props.filterOption}
                    dropdownRender={this.renderMenuOption}
                    open={this.state.isOpen}
                    onDropdownVisibleChange={(isOpen) => this.setState({ isOpen })}
                >
                    {(tourTypes || []).map(type => (
                        <AntOption key={type.id} value={type.id}>
                            <Span className="select-tour-types-item">
                                {type.name}
                                <Span className="button-section">
                                    <Wrapper
                                        className="btn-edit"
                                        onMouseDown={e => e.preventDefault()}
                                        onClick={e => { e.preventDefault(); this.onEditItem(e, type) }} >
                                        <Icon type="edit" />
                                    </Wrapper>
                                    <Wrapper
                                        className="btn-edit"
                                        onMouseDown={e => e.preventDefault()}
                                        onClick={e => { e.preventDefault(); this.onDeleteItem(e, type) }} >
                                        <Icon type="delete" />
                                    </Wrapper>
                                </Span>
                            </Span>
                        </AntOption>
                    ))}
                </AntSelect>
                {this.renderAddTourTypeModal()}
            </Fragment>
        )
    }

    renderMenuOption = (menu) => {
        const { t } = this.props;

        return (
            <Wrapper className="select-tour-types-dropdown">
                {menu}
                <Divider style={{ margin: '4px 0' }} />
                <Wrapper
                    style={{ padding: '0px 8px 4px 8px', cursor: 'pointer', width: '100%' }}
                    onMouseDown={e => e.preventDefault()}
                    onClick={this.onAddItem}
                >
                    <Icon type="plus" /> {t(`action.create`)}
                </Wrapper>
            </Wrapper>
        )
    }

    renderAddTourTypeModal = () => {
        const { t } = this.props;
        const { editTourType, isShowAddModal } = this.state;
        return (
            <Modal
                visible={isShowAddModal}
                title={`${editTourType && editTourType.id ? t('action.update') : t('action.create')} ${t('item.tour.tourTypes')}`}
                okText={editTourType && editTourType.id ? t('action.update') : t('action.create')} cancelText={t('action.cancel')}
                okButtonProps={{ disabled: !editTourType || !editTourType.name }}
                onOk={editTourType && editTourType.id ? this.editTourType : this.addTourType}
                onCancel={() => this.setState({ isShowAddModal: false, editTourType: new TourType() })}
            >
                <Input value={editTourType && editTourType.name}
                    autoFocus
                    placeholder={t('item.tour.tourTypeName')}
                    onChange={e => {
                        editTourType.name = e.target.value;
                        this.setState({ editTourType })
                    }}
                />
            </Modal>
        )
    }


    onAddItem = (e) => {
        e.stopPropagation();
        this.setState({ isShowAddModal: true, editTourType: new TourType() })
    }

    addTourType = () => {
        const { editTourType } = this.state;
        this.props.onCreate(editTourType);
        this.setState({ isShowAddModal: false, isOpen: true })
    }

    onEditItem = (e, type) => {
        e.stopPropagation();
        this.setState({ isShowAddModal: true, editTourType: type })
    }

    editTourType = () => {
        const { editTourType } = this.state;
        this.props.onUpdate(editTourType);
        // this.setState({ isShowAddModal: false, isOpen: true });
        this.setState({ isShowAddModal: false });
    }

    onDeleteItem = (e, tourType) => {
        const { t, selections } = this.props;
        const { confirm } = Modal;
        this.setState({ isOpen: false });
        e.stopPropagation();
        confirm({
            title: t(`notification.sureRemove`),
            content: `"${tourType.name}"`,
            okText: t(`action.remove`),
            cancelText: t(`action.cancel`),
            onOk: () => {
                this.props.onChange(selections.filter(item => item.id !== tourType.id).map(item => item.id));
                this.props.onDelete(tourType);
                this.setState({ isOpen: true });
            },
        });
    }

}

TourTypes.defaultProps = {
    onChange: (ids) => { },
    filterOption: (input, option) => { },
    onCreate: tourType => { },
    onUpdate: tourType => { },
    onDelete: tourType => { },
    selections: [],
    tourTypes: [],
    loading: false,
}

